<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1">
<h1 class="title"><span class="bold">IRGUN</span></h1>
<p class="subtitle"><span class="bold">REVISIONIST ZIONISM 1931–1948</span></p>
<p class="author"><span class="bold">GERRY VAN TONDER</span></p>
<div class="pub"><img alt="image" src="images/pub.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?8d24bd3e